const styles = (theme) => ({
	container: {
		width: "450px",
		borderRadius: "16px",
	},
	containerForm: {
		padding: "20px",
		display: "flex",
		flexDirection: "column",
		gap: 1.2,
	},
	textfield: {
		//margin: "5px 0px",
	},
	containerTitulo: {
		p: 2,
		pb: "4px",
		display: "flex",
		justifyContent: "space-between",
	},
	buttonCancel: {
		color: "secondary.main",
	},
	containerButtons: {
		padding: "10px",
		width: "100%",
		display: "flex",
		justifyContent: "end",
	},
});

export default styles;
